module.exports = __webpack_public_path__ + "img/wz-8-5-3.bedfd82e.jpg";